module.exports = __webpack_public_path__ + "e0101fc8a6d1187fdc578a13b1f1cbc7.svg";